<template>
  <div>
    <AppMenu>
      <template v-slot:bottomrightincontainer>
        <img src="../../assets/logo.png" width="176" height="72" />
      </template>
    </AppMenu>
    <h1>{{ errorText }}</h1>
    <div class="link"><a href="/">Retour à l'accueil</a> (dans {{ countdown }}s)</div>
  </div>
</template>

<script>
import AppMenu from '@Components/Menu.vue';
export default {
  components: {
    AppMenu,
  },
  props: ['errorText'],
  data() {
    return {
      countdown: 0,
    };
  },
  mounted() {
    this.countdown = 5;
    this.redirectTimer = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        this.goToHome();
      }
    }, 1000);
  },
  methods: {
    goToHome() {
      clearInterval(this.redirectTimer);
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.link {
  display: block;
  margin-top: 30px;
}
</style>
